<template>
  <div
    v-if="info"
    class="important-info-wrapper"
    id="important-info"
  >
    <FoldSection title="Know before you book">
      <div class="section-sep-heading-detail">
        <h4 class="info-disclaimer">
          Before you travel, please read our important noted about
          possible disruptions & site entrance requirements.
        </h4>
        <div v-show="toggle">
          <b-card>
            <div class="info-detail" v-html="info"></div>
          </b-card>
        </div>
        <button
          v-if="onDesktop"
          v-b-toggle="'collapse2'"
          class="show-info btn-anim trans-gold"
          @click="this.onToggle"
        >
          {{ toggle ? "Hide" : "Show" }} Information
        </button>
      </div>
    </FoldSection>
  </div>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'

import FoldSection from "@/components/containers/FoldSection"
export default {
  name: 'ImportantInfo',
  components: {
    FoldSection
  },
  props: {
    info: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'screenWidth'
    ]),
    onDesktop () {
      return this.screenWidth > 768
    }
  },
  data() {
    return {
      toggle: !this.onDesktop,
    };
  },
  mounted () {
    this.toggle = !this.onDesktop
  },
  watch: {
    screenWidth (from, to) {
      this.toggle = !this.onDesktop
    }
  },
  methods: {
    onToggle () {
      this.toggle = !this.toggle
      if (!this.toggle) {
        const headerDiv = $('#important-info')
        $("html, body").animate(
          {
            scrollTop: headerDiv.offset().top - 120
          },
          400
        );
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$text-color: $blackberry;
.important-info-wrapper {
  #collapse2 {
    opacity: 1;
    @media only screen and (max-width: 1200px) {
      position: initial;
    }
  }
  .info-disclaimer {
    color: $text-color;
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
  }
  .info-detail {
    font-family: $font-serif;
    font-size: 16px;
    color: $text-color;
    line-height: 22px;
    font-weight: 400;
    letter-spacing: 0 !important;
    &::v-deep p {
      font-size: 16px;
      color: $text-color;
      line-height: 22px;
      letter-spacing: 0 !important;
    }
  }
}


</style>